module.exports = __webpack_public_path__ + "img/020023.356220d2.png";